






























































































































































import { Vue, Component } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import VueToExcel from 'vue-json-excel';
import EventBus, { Event } from '@/event.bus'
import Pagination from '@/domain/pagination.entity';
import UnboundInstance from '@/domain/contract/entity/unbound-instance.entity';
import ContractService from '@/domain/contract/service/contract.service';
import InstanceService from '@/domain/contract/service/instance.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store'
import DateHandler from '@/shared/utils/date-format';
import InstanceFilter from '@/domain/contract/entity/instance-filter.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import Response from '@/domain/response.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractModal from '@/views/instances/contract-modal.component.vue/contract-modal.component.vue';
import InstancesTransfer from '@/views/instances/instances-transfer-modal/instances-transfer-modal.vue';
import FilterComponent from './instance-filter.component.vue';
import Header from './header.json';
import InstanceStatusFactory from './InstanceStatusFactory';
import InstanceUtils from './instance-utils';
import InstanceAddJustificationDialog from './instance-add-justification-dialog.component.vue';

const STATUS_LABELS = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  UNBOUND: 'Sem vínculo',
};

@Component({
  components: {
    FilterComponent,
    VbPagination,
    VbTooltipSlot,
    ContractModal,
    VueToExcel,
    ModalWarning,
    InstancesTransfer,
    InstanceAddJustificationDialog,
  },
})
export default class InstanceDataTable extends Vue {
  showFilter: boolean = false;

  header = Header;

  showContractModal = false;

  showInactivateModal = false;

  modalKey = 0;

  inactiveModalKey = 0;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'createdDate|desc',
  });

  selectedInstances: UnboundInstance[] = [];

  unboundInstances: UnboundInstance[] = [];

  businessUnitId: string = '';

  currentSelectedBusinessUnit: BusinessUnit = new BusinessUnit({});

  businessUnitList: BusinessUnit[] = [];

  showAlert: boolean = false;

  showAlertCount = 0;

  loading: boolean = true;

  xlsFields: any = {
    Código: 'code',
    Descrição: 'description',
    'ID Contrato': 'externalId',
    'Data de Criação': 'createdDate',
    'Data de Inativação': 'inactivatedDate',
    Status: 'status',
    Justificativa: 'justification',
    Observação: 'observation',
  };

  inactivateMessage: string = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as instâncias serão imediatamentes inativadas.';

  instanceStatusFactory!: InstanceStatusFactory;

  filter: InstanceFilter = new InstanceFilter(
    {
      status: this.getInitialStatusFilter(),
      competence: this.$route.query.competence.toString(),
    },
  );

  transferInstancesModalKey = 0;

  showTransferInstancesModal = false;

  showInstanceAddJustificationModal = false;

  exportToXLS(): Promise<UnboundInstance[]> {
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    return InstanceService.getUnboundInstances(pagination, this.businessUnitId, this.filter)
      .then((response: Response) => response.content.map((it) => ({
        ...it,
        status: STATUS_LABELS[it.status] || '',
      })));
  }

  openModal() {
    this.modalKey += 1;
    this.showContractModal = true;
  }

  openModalTransferInstances() {
    this.transferInstancesModalKey += 1;
    this.showTransferInstancesModal = true;
  }

  openInactivateModal() {
    this.inactiveModalKey += 1;
    this.showInactivateModal = true;
  }

  closeInactivateModal() {
    this.showInactivateModal = false;
  }

  showHelpAlert() {
    if (this.showAlertCount === 0) {
      this.showAlert = true;
      this.showAlertCount += 1;
      setTimeout(() => this.showAlert = false, 5000)
    }
  }

  bindInstances(contractId: string) {
    const selectedInstances: any[] = this.selectedInstances.map(this.parseSelectedInstaces)
    ContractService.bindUnboundInstances(this.businessUnitId, contractId, selectedInstances)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Instâncias vinculadas com sucesso');
        this.findInstances(this.filter);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  inactivateInstances() {
    const selectedInstances: any[] = this.selectedInstances.map(this.parseSelectedInstaces)
    InstanceService.inactivateInstance(this.businessUnitId, selectedInstances)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Instâncias inativadas com sucesso');
        this.findInstances(this.filter);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(this.closeInactivateModal);
  }

  validateDisabledTransferInstances(): boolean {
    const selectedItens: any[] = this.selectedInstances.map(this.parseSelectedInstaces);
    if (selectedItens.length === 0) {
      return true;
    }
    const bounded = selectedItens.filter(
      (el: UnboundInstance) => (el.externalId || '').length > 0,
    ).length;
    return (bounded > 0);
  }

  transferInstances(destinationId: string) {
    if (destinationId === this.businessUnitId) {
      return
    }
    const selectedInstances: any[] = this.selectedInstances.map(this.parseSelectedTransferInstances)
    InstanceService.transferInstances(this.businessUnitId, destinationId, selectedInstances)
      .then(() => {
        VbSnackbarService.showSuccess('Instâncias transferidas de unidade com sucesso');
        this.findInstances(this.filter);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(this.closeTransferInstancesModal);
  }

  closeTransferInstancesModal() {
    this.showTransferInstancesModal = false;
  }

  created() {
    this.currentSelectedBusinessUnit = UserBusinessUnitService.currentBusinessUnit;
    this.businessUnitList = UserBusinessUnitService.businessUnits;
    this.businessUnitId = this.currentSelectedBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      this.currentSelectedBusinessUnit = businessUnit;
      this.businessUnitList = UserBusinessUnitService.businessUnits;
      this.businessUnitId = businessUnit.id;
      this.pagination.page = 1
      this.findInstances(this.filter);
    })
    this.findInstances(this.filter);
  }

  parseSelectedTransferInstances(selectedInstance: UnboundInstance) {
    return selectedInstance.code;
  }

  parseSelectedInstaces(selectedInstance: UnboundInstance) {
    return {
      ...selectedInstance,
      createdDate: DateHandler.localToTimestamp(selectedInstance.createdDate),
      inactivatedDate: selectedInstance.inactivatedDate != null
        ? DateHandler.localToTimestamp(selectedInstance.inactivatedDate) : null,
    };
  }

  applyFilter(filter: InstanceFilter) {
    this.filter = InstanceFilter.of(filter);
    this.pagination.page = 1;
    this.findInstances(this.filter);
  }

  findInstances(filter: InstanceFilter) {
    if (this.businessUnitId) {
      this.loading = true;
      InstanceService.getUnboundInstances(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.unboundInstances = UnboundInstance.ofList(response.content);
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
          this.selectedInstances = [];
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => { this.loading = false; });
    }
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findInstances(this.filter);
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  getInitialStatusFilter(): string {
    this.instanceStatusFactory = new InstanceStatusFactory();
    const withConsumption = InstanceUtils.getInstanceUrlQueryParams(
      this.$route.query.withConsumption,
    );
    const status = this.$route.query.status.toString();
    return this.instanceStatusFactory.getInstanceStatus(
      status,
      withConsumption,
    );
  }

  openAddJustificationModal(): void {
    const { instanceAddJustificationModal }: any = this.$refs;
    instanceAddJustificationModal.clear();
    this.showInstanceAddJustificationModal = true;
  }

  everySelectedInstanceIsUnbound(): boolean {
    if (this.selectedInstances.length === 0) return false;
    return this.selectedInstances.every((it) => it.status !== 'ACTIVE');
  }

  getStatusLabel(status: string): string {
    return STATUS_LABELS[status] || '';
  }
}

